import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { stats } from "@/mocks/siteData";

const hotWords = ["忘关麦", "报价失误", "连线失控", "人设崩塌", "提词器穿帮"];

export default function Hero() {
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();

  const go = (value: string) => {
    const trimmed = value.trim();
    navigate(trimmed ? `/category?q=${encodeURIComponent(trimmed)}` : "/category");
  };

  return (
    <section className="relative w-full">
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20empty%20livestream%20stage%20with%20a%20broken%20neon%20sign%20glowing%20red%20on%20a%20dark%20concrete%20wall%2C%20scattered%20product%20boxes%20on%20the%20floor%2C%20cinematic%20moody%20atmosphere%2C%20deep%20shadows%2C%20no%20people&width=1600&height=900&seq=fail-hero-01&orientation=landscape"
          alt="直播翻车现场主题抽象背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/85 via-foreground-950/75 to-foreground-950/90"></div>
      </div>

      <div className="relative w-full px-4 md:px-8 pt-16 pb-14 md:pt-24 md:pb-20">
        <div className="max-w-4xl">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-500/20 border border-primary-400/40 text-xs text-primary-100 mb-6">
            <span className="w-1.5 h-1.5 rounded-full bg-primary-400 animate-pulse"></span>
            网红翻车现场 · 持续更新中
          </span>

          <h1 className="font-heading font-black text-3xl md:text-5xl lg:text-6xl leading-[1.15] text-background-50">
            网红翻车现场直击：
            <br className="hidden md:block" />
            直播事故、名场面与视频回放全记录
          </h1>

          <p className="mt-5 md:mt-7 text-sm md:text-lg leading-relaxed text-background-200 max-w-2xl">
            收录网红翻车直播事故、翻车视频回放与关键截图。从带货失误到连线失控，
            <span className="text-background-50 font-medium">名场面瞬间一网打尽</span>
            ，帮你快速定位吃瓜重点，看透每次翻车的真实经过。
          </p>

          <div className="mt-8 md:mt-10 max-w-2xl">
            <div className="flex flex-col sm:flex-row gap-2.5 p-2 rounded-lg bg-background-50/95 backdrop-blur">
              <div className="relative flex-1">
                <span className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center text-foreground-400">
                  <i className="ri-search-line text-base"></i>
                </span>
                <input
                  type="search"
                  value={keyword}
                  onChange={(event) => setKeyword(event.target.value)}
                  onKeyDown={(event) => {
                    if (event.key === "Enter") go(keyword);
                  }}
                  placeholder="搜索事件、主播或关键词，例如：忘关麦"
                  className="w-full h-11 pl-10 pr-3 rounded-md bg-background-100 border border-transparent text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400"
                />
              </div>
              <button
                type="button"
                onClick={() => go(keyword)}
                className="h-11 px-6 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
              >
                立即查找
              </button>
            </div>
            <div className="mt-3 flex items-center gap-2 flex-wrap">
              <span className="text-xs text-background-300">热门搜索</span>
              {hotWords.map((word) => (
                <button
                  key={word}
                  type="button"
                  onClick={() => go(word)}
                  className="px-2.5 py-1 rounded-full border border-background-50/25 text-xs text-background-100 hover:border-accent-400 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {word}
                </button>
              ))}
            </div>
          </div>

          <dl className="mt-10 md:mt-14 grid grid-cols-2 lg:grid-cols-4 gap-x-4 gap-y-6 pt-8 border-t border-background-50/15 max-w-3xl">
            {stats.map((item) => (
              <div key={item.label}>
                <dd className="font-heading font-bold text-2xl md:text-3xl text-background-50">
                  {item.value}
                  <span className="text-sm font-normal text-background-300 ml-1">{item.unit}</span>
                </dd>
                <dt className="mt-1 text-xs text-background-300">{item.label}</dt>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}